import { Article, LegalScreen } from '../components/legal';
import { InfoBox } from '../components/ui';

/**
 * お問い合わせ。
 *
 * 窓口はまだ用意していないので「準備中」で出す。窓口が無いぶんページが何もしないと
 * 困るので、実際にいちばん多いはずの質問への答えを先に置いてある。
 *
 * フォームを用意したら、下の「準備中」の箱を <a href="…"><Button/></a> に差し替える。
 * それ以外は触らなくていい。
 *
 * 窓口を閉じたままにしておくと効いてくるのは2点。広告（AdSense）の審査では連絡が
 * 取れることがサイトの品質として見られる。それと、不具合の報告が届かない。
 */
const FAQ = [
  {
    q: '共有URLをなくしてしまいました',
    a: '同じグループのメンバーに、共有URLを送ってもらってください。共有URLは暗号化した状態でのみサーバーに保存しているため、運営者にも復元できません。',
  },
  {
    q: 'グループを削除したい',
    a: 'グループの設定画面から、いつでも削除できます。メンバー・対局・ルールもあわせて消えます。',
  },
  {
    q: '記録はいつまで残りますか',
    a: '最後に操作してから12か月です。グループを開くたびに期限は延長されます。',
  },
];

const OPERATOR = [
  { k: '運営者', v: 'takuan' },
  { k: 'サービス名', v: '雀点（じゃんてん）' },
  { k: 'URL', v: 'https://jongten.com/' },
];

export function ContactPage() {
  return (
    <LegalScreen title="お問い合わせ">
      <Article title="お問い合わせ窓口">
        <InfoBox>
          お問い合わせフォームは現在メンテナンス中です。ご不便をおかけしております。準備ができ次第、このページでご案内します。
        </InfoBox>
        {/* Button の disabled と同じ色。押せないことが色で分かればよく、
            本物の <button disabled> にする必要はない */}
        <div className="rounded-[10px] bg-off px-4 py-3.5 text-center text-[15px] font-bold text-off-ink">
          準備中
        </div>
      </Article>

      <Article title="よくあるご質問">
        {FAQ.map((f) => (
          <div key={f.q}>
            <div className="font-bold">{f.q}</div>
            <p className="mt-0.5">{f.a}</p>
          </div>
        ))}
      </Article>

      <Article title="運営者">
        <dl className="flex flex-col">
          {OPERATOR.map((o) => (
            <div key={o.k} className="flex gap-2.5 border-b border-line py-2 last:border-b-0">
              <dt className="w-[92px] shrink-0 text-ink-soft">{o.k}</dt>
              <dd className="min-w-0 break-all">{o.v}</dd>
            </div>
          ))}
        </dl>
        <p className="text-[12.5px] text-ink-soft">個人が趣味で運営しているサービスです。</p>
      </Article>
    </LegalScreen>
  );
}
